/**
 * Apresentação dos badges de status da grid de Expedição — extraída da view
 * para ser testável sem DOM (TMS-8132).
 *
 * Contrato de entrada: o objeto `{ valor, descr }` devolvido por
 * `ListItemValorResource` do isend-backend. Como o resource é montado com
 * `whenLoaded`, o objeto inteiro pode não vir no payload — daí as funções
 * aceitarem `null`/`undefined` sem quebrar.
 *
 * Contrato de saída: `{ classe, rotulo }`. Nunca devolve `rotulo` vazio; era
 * exatamente isso que deixava a coluna em branco para o status 4 (Erro) e
 * escondia da operação o motivo de a carga estar travada (SDK-101141).
 *
 * `descr` do backend sempre tem precedência sobre o literal daqui: quem manda
 * no texto é o cadastro da lista, não o front. O literal é rede de segurança.
 */
import {
  StatusCargaEnum,
  StatusProcessoExpedicaoEnum,
} from "../../enums/GeneralEnums";

const CLASSE_PADRAO = "badge badge-secondary";
const ROTULO_PADRAO = "Não informado";

/* Preserva o visual atual de 1, 2 e 3 — a AC proíbe regressão. */
const BADGES_PROCESSO_EXPEDICAO = Object.freeze({
  [StatusProcessoExpedicaoEnum.PENDENTE]: {
    classe: "badge badge-danger",
    rotulo: "Pendente",
  },
  [StatusProcessoExpedicaoEnum.EM_ANDAMENTO]: {
    classe: "badge badge-warning",
    rotulo: "Em andamento",
  },
  [StatusProcessoExpedicaoEnum.CONCLUIDO]: {
    classe: "badge badge-success",
    rotulo: "Concluído",
  },
  /* Classe distinta de Pendente, senão os dois estados ficam iguais na tela. */
  [StatusProcessoExpedicaoEnum.ERRO]: {
    classe: "badge badge-dark",
    rotulo: "Erro",
  },
});

const BADGES_STATUS_CARGA = Object.freeze({
  [StatusCargaEnum.GERADA]: {
    classe: "badge badge-warning",
    rotulo: "Gerada",
  },
  [StatusCargaEnum.PENDENTE]: { classe: CLASSE_PADRAO, rotulo: "Pendente" },
  [StatusCargaEnum.EXPEDIDA]: {
    classe: "badge badge-success",
    rotulo: "Expedida",
  },
  [StatusCargaEnum.INATIVA]: { classe: CLASSE_PADRAO, rotulo: "Inativa" },
  [StatusCargaEnum.TRANSFERIDA]: {
    classe: CLASSE_PADRAO,
    rotulo: "Transferida",
  },
  [StatusCargaEnum.FINALIZADA]: { classe: CLASSE_PADRAO, rotulo: "Finalizada" },
});

function montarBadge(badges, listItem) {
  const descr = listItem && listItem.descr ? String(listItem.descr) : "";
  const valor = listItem == null ? null : listItem.valor;
  const badge = valor == null ? undefined : badges[String(valor)];

  if (!badge) {
    return { classe: CLASSE_PADRAO, rotulo: descr || ROTULO_PADRAO };
  }

  return { classe: badge.classe, rotulo: descr || badge.rotulo };
}

/**
 * Badge da coluna "Processo expedição" (`rowData.statusProcessoExpedicao`).
 *
 * @param {{valor: number|string, descr: string}|null|undefined} statusProcesso
 * @returns {{classe: string, rotulo: string}}
 */
export function badgeProcessoExpedicao(statusProcesso) {
  return montarBadge(BADGES_PROCESSO_EXPEDICAO, statusProcesso);
}

/**
 * Badge da coluna "Status" (`rowData.status`).
 *
 * @param {{valor: number|string, descr: string}|null|undefined} status
 * @returns {{classe: string, rotulo: string}}
 */
export function badgeStatusCarga(status) {
  return montarBadge(BADGES_STATUS_CARGA, status);
}
